import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../components/Form/Field'

import { formatNumber } from '../../../../../../helpers/numbers'

import { getMaxDailyImpressions, IMPRESSIONS } from '../fields'

const DailyRemainingImpressionsFields = ({
  formik,
  remainingImpressions,
  startDate,
  endDate,
  initialCampaignImpressionsDaily = 0
}) => {
  const { t } = useTranslation()

  const maxDailyImpressions = getMaxDailyImpressions({
    remainingImpressions,
    startDate,
    endDate,
    initialCampaignImpressionsDaily
  })

  return (
    <FieldLabelWrapper label={t('Impressions')} labelFor={IMPRESSIONS}>
      <p>
        {t(
          `Your total remaining impressions is ${formatNumber(
            remainingImpressions
          )} therefore the maximum daily impressions you can enter here is ${formatNumber(maxDailyImpressions)}`
        )}
      </p>
      <Field
        type="number"
        formik={formik}
        name={IMPRESSIONS}
        placeholder={'Impressions'}
        autoComplete="off"
        inputMode="numeric"
      />
    </FieldLabelWrapper>
  )
}

export default DailyRemainingImpressionsFields
